import React, { ReactNode, Ref, forwardRef } from 'react';
import { classNames } from '../../utils';
import { TextInput } from './text-input';
import MoneyIcon from '../../images/Money.svg';
import {
  NumberFormatValues,
  NumericFormat,
  OnValueChange,
  SourceInfo,
} from 'react-number-format';
import { FieldError, useFormContext } from 'react-hook-form';

interface MoneyInputProps {
  className?: string;
  type?: React.HTMLInputTypeAttribute;
  name?: string;
  placeholder?: string;
  leftIcon?: ReactNode;
  value?: string | number | undefined | null;
  onBlur?: React.FocusEventHandler<HTMLInputElement>;
  onValueChange?: (values: NumberFormatValues, sourceInfo: SourceInfo) => void;
  onChange?: (val?: number) => void;
  onSubmit?: (value: number | string | null) => void;
  disabled?: boolean;
  rightIcon?: ReactNode;
  fieldErrorOverride?: FieldError;
  autoFocus?: boolean;
  inputClassName?: string;
  allowNegative?: boolean;
  submitOnEnter?: boolean;
  hideMoneyIcon?: boolean;
  max?: number;
  min?: number;
  leftIconClassName?: string;
  rightIconClassName?: string;
  variant?: string;
  showBorder?: boolean;
}

// eslint-disable-next-line
export const MoneyInput: React.FC<MoneyInputProps> = (props) => {
  const {
    min,
    max,
    className,
    type,
    name,
    value,
    disabled,
    placeholder,
    leftIcon,
    onBlur,
    onValueChange,
    onChange,
    fieldErrorOverride,
    autoFocus,
    inputClassName = '',
    allowNegative,
    submitOnEnter,
    onSubmit,
    hideMoneyIcon = false,
    leftIconClassName,
    rightIconClassName,
    variant,
    showBorder = true,
  } = props;

  const currentValue = value == null || value === 'undefined' ? '' : value;

  return (
    <NumericFormat
      disabled={disabled}
      value={currentValue ?? ''}
      onValueChange={(values, sourceInfo) => {
        sourceInfo?.event?.preventDefault();
        onValueChange?.(values, sourceInfo);
        onChange?.(values.floatValue ?? undefined);
      }}
      type="text"
      allowedDecimalSeparators={['.']}
      decimalScale={3}
      allowLeadingZeros
      thousandSeparator=","
      customInput={TextInput}
      leftIcon={hideMoneyIcon ? null : <img src={MoneyIcon} />}
      rightIcon={props.rightIcon}
      name={name}
      onBlur={onBlur}
      placeholder={placeholder}
      className={className}
      fieldErrorOverride={fieldErrorOverride}
      autoFocus={autoFocus}
      inputClassName={inputClassName}
      allowNegative={allowNegative}
      submitOnEnter={submitOnEnter}
      onSubmit={onSubmit}
      isAllowed={(values) => {
        const { floatValue } = values;

        if (floatValue === undefined) return true;

        if (min !== undefined && floatValue < min) return false;
        if (max !== undefined && floatValue > max) return false;

        return true;
      }}
      leftIconClassName={leftIconClassName}
      rightIconClassName={rightIconClassName}
      variant={variant}
      showBorder={showBorder}
    />
  );
};
